<template>
  <div>
    <el-card
      shadow="never"
      :body-style="{
        padding: '20px 15px',
      }"
    >
      <ProductMaterial
        :proofingCode="proofingCode"
        :disabled="disabled"
        class="mb-4"
      />
      <ProductInfo :proofingCode="proofingCode" :disabled="disabled" />
    </el-card>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import ProductMaterial from './product-material'
import ProductInfo from './product-info'
export default {
  mixins: [EditLoading],
  props: {
    proofingCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  components: { ProductMaterial, ProductInfo },
}
</script>
<style lang="scss" scoped></style>
